import { render, staticRenderFns } from "./DailyResultBanner.vue?vue&type=template&id=0bc4d340&scoped=true&"
import script from "./DailyResultBanner.vue?vue&type=script&lang=js&"
export * from "./DailyResultBanner.vue?vue&type=script&lang=js&"
import style0 from "./DailyResultBanner.vue?vue&type=style&index=0&id=0bc4d340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4d340",
  null
  
)

export default component.exports